import classNames from "classnames";

import { FC, Fragment } from "react";
import useI18n from "../../hooks/useTranslations";
import { getMinutesRoundedTimestamp } from "../../utils";
import ImageBorderBox from "./BorderBox";
import styles from "./ItemsHelpModal.module.css";
import ModalDialog from "./ModalDialog";

interface item {
  id: string;
  title: string;
  description?: string;
  name?: string;
  image?: string;
}

type ItemsHelpModalProps = {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onSelect?: (item: item) => void;
  items: item[];
};

export const ItemsHelpModal: FC<ItemsHelpModalProps> = ({
  title,
  items,
  isOpen,
  onClose,
  onSelect,
}: ItemsHelpModalProps) => {
  const i18n = useI18n();

  return (
    <>
      {!!isOpen && (
        <ModalDialog
          title={title}
          onClose={onClose}
          isSubmitting={false}
          actions={[{ title: i18n.translation.common.close, onClick: onClose }]}
          fitContent
        >
          <div
            className={classNames(styles.grid, {
              [styles.grid1]: items.length === 1,
              [styles.grid2]: items.length > 1,
            })}
          >
            {items.map((item) => (
              <Fragment key={item.id}>
                <ImageBorderBox
                  onClick={onSelect ? () => onSelect(item) : undefined}
                  showIsMissing={true}
                  title={item.title}
                  subTitle={item.name}
                  description={item.description}
                >
                  <div className={styles.img}>
                    {item.image ? (
                      <ImageBorderBox.Image
                        src={`${import.meta.env.VITE_BUCKET_URL}${item.image}?${getMinutesRoundedTimestamp()}`}
                      />
                    ) : (
                      ImageBorderBox.PlaceHolder
                    )}
                  </div>
                </ImageBorderBox>
              </Fragment>
            ))}
          </div>
        </ModalDialog>
      )}
    </>
  );
};
